import { TruClose } from '@uswitch/spark-icons/tru'
import React from 'react'

import * as styles from './styles'

/**
 * The direct child of the ModalTrigger must be an html element not a react component
 */
export const ModalTrigger = ({
  children,
  condition = true,
  criticalJs = true,
  onClick = (event) => {},
  id,
  ...props
}) => {
  if (!condition) return children

  const modalTriggerProps = criticalJs
    ? {
        // if criticalJs we want to render the stimulus trigger
        'data-controller': 'trigger',
        'data-trigger-modal-outlet': `.stim--${id}`,
        'data-action': 'click->trigger#open:stop:prevent'
      }
    : {
        // render the react trigger
        onClick,
        'data-modal-trigger': id
      }

  return React.cloneElement(children, {
    ...props,
    ...modalTriggerProps,
    'data-modal-item': 'trigger'
  })
}

export const ModalContainer = ({ children, id, criticalJs = true, onClick = (event) => {}, isOpen = false }) => {
  // the stimulus modal container
  if (criticalJs)
    return (
      <div
        className={`stim--${id} modal-container`}
        data-controller='modal'
        data-modal-target='wrapper'
        sx={styles.container}
        data-modal-item='container'
      >
        <div sx={styles.modal} data-modal-target='container'>
          <button sx={styles.closeButton} data-action='click->modal#hide:stop:prevent'>
            <TruClose color='#141414' size={18} strokeWidth={2} />
          </button>

          {children}
        </div>
      </div>
    )

  // the react modal container
  return (
    <div
      className='modal-container'
      sx={styles.container}
      data-modal-open={isOpen}
      role='link'
      tabIndex={0}
      data-modal-container={id}
      onClick={onClick}
      onKeyUp={onClick}
      data-modal-item='container'
    >
      <div sx={styles.modal}>
        <button sx={styles.closeButton} onClick={onClick}>
          <TruClose color='#141414' size={18} strokeWidth={2} />
        </button>
        {children}
      </div>
    </div>
  )
}
